import StoredLayout from '../../layouts/StoredLayout'
import GoogleMaps from './GoogleMaps'
export default StoredLayout(GoogleMaps)
